
/*eslint-disable*/
import React, { Suspense, useEffect, lazy, useState } from "react";
import { withRouter } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';
import ContentWrapper from "../../template/Layout/ContentWrapper";
import ContainerImg from "../../../resources/ContainerIcon.png";

import '../cards.scss'

const NextToArrive = lazy(() => (import('./NextToArrive/Index')))
const Arrived = lazy(() => (import('./Arrived/Index')))

function Container(props) {
  let [BanderaArrive, setBanderaArrived] = useState(false)
  let [BanderaNexto, setBanderaNexto] = useState(false)

  const [idContainerArrived, setIdContainerArrived] = useState(1)
  const [idContainerNexto, setIdContainerNexto] = useState(1)


  function getIdContainerArrived(id) {
    if (id) {
      setIdContainerArrived(id)
    }
    setBanderaArrived(!BanderaArrive)
  }

  function getIdContainerNextoArrived(id) {
    if (id) {
      setIdContainerNexto(id)
    }
    setBanderaNexto(!BanderaNexto)
  }


  return (
    < ContentWrapper >
      <div className="content-heading">
        <img
          src={ContainerImg}
          style={{ width: "1.5em", paddingRight: 5 }}
          alt="..."
        ></img>
        {
          <b>Container Management</b>
        }
      </div>
      <div>
        <Tab
          defaultActiveIndex={0}
          menu={{ secondary: true }}
          panes={[
            {
              menuItem: 'Next to Arrive',
              render: () => <Suspense fallback={<div>Loading...</div>}><NextToArrive Bandera={BanderaNexto} idContainer={idContainerNexto} getIdContainer={getIdContainerNextoArrived} /></Suspense>
            },
            {
              menuItem: 'Arrived',
              render: () => <Suspense fallback={<div>Loading...</div>}><Arrived Bandera={BanderaArrive} idContainer={idContainerArrived} getIdContainer={getIdContainerArrived} _user={props._user} /></Suspense>,
            },
          ]}
        />
      </div>
    </ContentWrapper >
  );
}

export default withRouter(Container);

